import { Box, Typography, Button, Modal } from "@mui/material"
import useStyles from "./style"
import { icons, images } from "../../utils"
import { Link } from "react-router-dom"
import { lists } from "../../utils"
import DateToday from "../Date"

const BasicModal = ({
  open,
  handleClose,
  pqrType,
  errorModal,
  eps,
  service,
  params,
  ticketData,
  newPqr,
}) => {
  const classes = useStyles()

  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className={classes.modal}>
          <Box className={classes.box1}>
            <Box className={classes.logo}>
              <img
                src={images.logoSanDiego}
                className={classes.logo}
                alt="logo"
              />
            </Box>
            <Box className={classes.msgContainer}>
              <Typography className={classes.msg}>
                {errorModal === false
                  ? pqrType === "Petición"
                    ? lists.modal.petitionMsg1
                    : lists.modal.pqrMsg1
                  : lists.modal.errorMsg1}
                <br />
                <br />{" "}
                <b>
                  {errorModal === false
                    ? pqrType === "Petición"
                      ? lists.modal.petitionMsg2
                      : lists.modal.pqrMsg2
                    : lists.modal.errorMsg2}
                </b>
              </Typography>
            </Box>
            <Box className={classes.buttonsContainer}>
              <Button
                component={Link}
                to={
                  errorModal === false
                    ? `/searchpqrsf?num_radicado=${ticketData.ticket_id}`
                    : `/form/${params.document_type}/${params.document_num}`
                }
                className={classes.okButton}
                onClick={errorModal === false ? null : handleClose}
              >
                Ok
              </Button>
              <Box className={classes.createPqr}>
                {errorModal === false ? (
                  <Button className={classes.createButton} onClick={newPqr}>
                    Crear otra PQRSF
                  </Button>
                ) : (
                  ""
                )}
              </Box>
            </Box>
          </Box>
          <Box className={classes.box2}>
            <Box className={classes.logo2}>
              <img
                src={images.logoSanDiego}
                className={classes.logo2}
                alt="logo"
              />
            </Box>
            <Box className={classes.top}>
              <Box className={classes.topContent}>
                <Box className={classes.title}>
                  {errorModal === false
                    ? pqrType === "Petición"
                      ? lists.modal.petitionMsg3
                      : lists.modal.pqrMsg3
                    : lists.modal.errorMsg4}
                </Box>
                <Box className={classes.icon}>
                  {errorModal === false ? icons("check") : icons("cancel")}
                </Box>
              </Box>
            </Box>
            <Box className={classes.bot}>
              <Box className={classes.botContent}>
                <DateToday />
                {errorModal === false ? (
                  <>
                    <Typography className={classes.fields}>
                      {lists.modal.ticket_id}: {ticketData.ticket_id}
                    </Typography>
                    <Typography className={classes.fields}>
                      {pqrType === "Petición"
                        ? ""
                        : lists.pqrTypeTitle[pqrType]}
                    </Typography>
                    <Typography className={classes.fields}>{eps}</Typography>
                    <Typography className={classes.fields}>--</Typography>
                    <Typography className={classes.fields}>
                      {service}
                    </Typography>
                  </>
                ) : (
                  <Typography className={classes.fields}>
                    {lists.modal.errorMsg3}
                  </Typography>
                )}
              </Box>
            </Box>
          </Box>
        </Box>
      </Modal>
    </>
  )
}

export default BasicModal
